"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgFacebookAlt(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M14.164 24V13.056h3.678l.547-4.262h-4.225V6.069c0-1.232.343-2.075 2.112-2.075h2.261V.176C18.148.12 16.805.01 15.247.01c-3.26 0-5.485 1.993-5.485 5.644v3.15H6.074v4.263h3.688V24h4.402z"
  }));
}

var _default = SvgFacebookAlt;
exports.default = _default;